import type { IFuseOptions } from 'fuse.js';

/**
 * Fuse.js matching options for the Pro Studio node search / filter.
 *
 * PSTUDIO-3052: fuzzy matching is intentionally DISABLED. When searching across
 * thousands of nodes, specificity is critical (finding a literal typo, renaming
 * an exact variable), so a query must match as an exact, case-insensitive,
 * contiguous substring — not an approximate match.
 *
 * - `threshold: 0` requires a perfect match (no edit-distance tolerance).
 * - `ignoreLocation: true` lets that perfect match occur anywhere in the field;
 *   without it, `threshold: 0` would only match at the start of the string.
 *
 * Together they turn Fuse into a plain substring matcher while preserving its
 * multi-field / nested-key extraction. See Fuse.js docs, "Controlling Fuzziness".
 *
 * Only the *matching behaviour* lives here (not the searched `keys`/weights, which
 * stay with the Fuse instance in table-store.ts) so it can be unit-tested without
 * loading the heavy store module (it imports design-system / api-services / xstate
 * and cannot run in pro-studio's node Vitest env).
 */
export const NODE_SEARCH_FUSE_MATCH_OPTIONS: Pick<
  IFuseOptions<unknown>,
  'threshold' | 'ignoreLocation' | 'minMatchCharLength'
> = {
  threshold: 0,
  ignoreLocation: true,
  minMatchCharLength: 1,
};
